import { requestService as api } from "../Request.service";

const API_URL = {
  API_MANAGE: `/ERP/ju/manage.php`,
  API_SEARCH: `/ERP/ju/search.php`,
};

/* JU : รับสินค้าเข้าสต๊อกโดยตรง (ไม่ผ่านใบสั่งซื้อ) */
const JuService = () => {
  const get = (jucode) => api.get(`${API_URL.API_MANAGE}?code=${encodeURIComponent(jucode)}`);
  /* ค้นหาสินค้าจาก master ทุกประเภท */
  const items = (q = "", all = false) =>
    api.get(`${API_URL.API_MANAGE}?items=1${all ? "&all=1" : ""}&q=${encodeURIComponent(q)}`, { ignoreLoading: true });
  /* ข้อมูล Tags รูปแบบเดียวกับ GR */
  const tagsGet = (jucode) => api.get(`${API_URL.API_MANAGE}?tags=${encodeURIComponent(jucode)}`);

  const create = (parm = {}) => api.post(API_URL.API_MANAGE, { ...parm, action: "create" });
  const update = (parm = {}) => api.put(API_URL.API_MANAGE, parm);
  const confirm = (parm = {}) => api.post(API_URL.API_MANAGE, { ...parm, action: "confirm" });
  const cancel = (jucode) => api.post(API_URL.API_MANAGE, { jucode, action: "cancel" });

  const search = (parm = {}, config = {}) =>
    api.post(API_URL.API_SEARCH, parm, { ...config, cancle: true });

  return { get, items, tagsGet, create, update, confirm, cancel, search };
};

export default JuService;
